import { Chakra } from "@airhelp/react-ui-components";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { EnvelopeIcon } from "styles/icons";
import { useTranslations, useLanguage } from "contexts/LocalizationContext/hooks";
import getPageUrl from "utils/getPageUrl";
import config from "config/config";
import axios from "axios";
import { iterableListIds } from "pages/api/iterable/config";
import { Terms, FormSubmitButton, FormSuccessMessage, FormError } from "components/FormControl";
import type { BlogSubscribeBoxFormProps } from "./BlogSubscribeBoxForm.d";

const { Flex, FormControl, Input, InputGroup, InputLeftElement, chakra } = Chakra;

const Form = chakra("form");

const BlogSubscribeBoxForm = ({ mobileView }: BlogSubscribeBoxFormProps) => {
  const [isError, setIsError] = useState(false);
  const [hasSubscribed, setHasSubscribed] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = useForm();

  const watchTerms = watch("agreeWithTerms", false);
  const translations = useTranslations();
  const language = useLanguage();

  const termsTranslationVariables = {
    "%terms-link-attrs%": `href="${getPageUrl(
      language,
      "terms"
    )}" target="_blank" rel="noopener noreferrer" title="${translations(
      "terms_link_title"
    )}" style="text-decoration: underline"`,
    "%privacy-link-attrs%": `href="${getPageUrl(
      language,
      "privacy"
    )}" target="_blank" rel="noopener noreferrer" title="${translations(
      "terms_privacy_link_title"
    )}" style="text-decoration: underline"`,
  };

  const onSubmit = ({ email }) => {
    const payload = {
      listId: iterableListIds.blog,
      email,
    };

    try {
      axios.post(`${config.websiteUrl}/api/iterable/`, payload);
      setHasSubscribed(true);
    } catch (err) {
      setIsError(true);
      setHasSubscribed(false);
    }
  };

  return !hasSubscribed ? (
    <Form onSubmit={handleSubmit(onSubmit)} width="100%">
      <FormControl flexDir="column">
        <Flex justify={{ base: "flex-start", md: "center" }} mb={6}>
          <InputGroup w={mobileView ? "full" : { base: "full", md: 80 }}>
            <InputLeftElement pointerEvents="none">
              <EnvelopeIcon color="greyscale.500" w={5} h={4} />
            </InputLeftElement>
            <Input
              name="email"
              ref={register}
              required
              type="email"
              placeholder={translations("enter_email_placeholder")}
            />
          </InputGroup>
          <FormSubmitButton
            text={translations("subscribe")}
            isDisabled={!watchTerms}
            isLoading={isSubmitting}
            display={mobileView ? "none" : { base: "none", md: "block" }}
            w={{ base: "full", md: 32 }}
            ml={4}
          />
        </Flex>
        <Terms
          register={register({ required: true })}
          htmlContent={translations("agree_to_terms", termsTranslationVariables)}
          justifyContent={{ base: "left", md: "center" }}
        />
        <FormSubmitButton
          text={translations("subscribe")}
          isDisabled={!watchTerms}
          isLoading={isSubmitting}
          display={mobileView ? "block" : { base: "block", md: "none" }}
          w="full"
          mt={6}
        />
        {isError && (
          <FormError formErrorText={translations("subscribe_form_submit_error")} formError={isError} id="form-error" />
        )}
      </FormControl>
    </Form>
  ) : (
    <FormSuccessMessage text={translations("subscribe_form_submit_succesful")} />
  );
};

export default BlogSubscribeBoxForm;
